import { gql } from "@apollo/client"

const LONG_TEXT_JOB_STEP_FIELDS = gql`
  fragment LongTextJobStepFields on LongTextJobStep {
    id
    step
    number
    section
    name
    description
    responseType
    responseMandatory
    response
    skip
    notApplicable
    unresolvedActions
    hasResolvedActions
    completed @client
    completedAt
    completedBy {
      ...JobStepCompletedByFields
    }
    uploads {
      ...JobStepUploadsFields
    }
    notes {
      ...JobStepNotesFields
    }
  }
`

export { LONG_TEXT_JOB_STEP_FIELDS }
